import { render, staticRenderFns } from "./AddFiles.vue?vue&type=template&id=106cf9c5&scoped=true"
import script from "./AddFiles.vue?vue&type=script&lang=js"
export * from "./AddFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106cf9c5",
  null
  
)

export default component.exports